var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageHeader"},[(_vm.step)?_c('label',{staticClass:"pageHeader__step"},[_vm._v(_vm._s(_vm.step))]):_vm._e(),_c('label',{staticClass:"pageHeader__title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }